module.exports = __webpack_public_path__ + "img/service05.3e8ce6e9.png";